module.exports = __webpack_public_path__ + "img/doctor_step4.e9901c2e.png";